<template>
  <v-tooltip location="top" content-class="brick-tooltip-content">
    <template v-slot:activator="{ props }">
      <v-icon
        v-bind="props"
        :size="size ? size : 24"
        class="ml-2"
        :color="color ? color : 'grey-darken-1'">
        mdi-help-circle
      </v-icon>
    </template>
    <v-card
      color="white"
      elevation="0"
      class="brick-tooltip-card text-13 d-flex flex-column px-3 py-2"
      :style="`max-width: ${width ? width : 400}px; word-break: keep-all;`">
      <div v-if="overTitle" class="d-flex">
        <v-icon size="small" color="orange" class="mr-1">mdi-alert</v-icon>
        <span
          class="text-black text-16 font-weight-bold d-flex align-center"
          :class="description ? 'my-1' : ''">
          {{ `${overTitle}` }}
        </span>
      </div>
      <div v-if="description">
        <span class="text-black" v-if="typeof description === 'string'">
          {{ description }}
        </span>
        <div
          v-for="(desc, index) in description"
          :key="index"
          v-if="typeof description === 'object'"
          :class="index !== 0 ? 'mt-4' : ''">
          {{ desc }}
        </div>
      </div>
      <div v-if="title">
        <span
          class="text-black text-16 font-weight-bold d-flex align-center"
          :class="description ? 'mt-4' : ''">
          {{ `※ ${title}` }}
        </span>
      </div>
      <div v-if="subDescription">
        <span class="text-black"> {{ subDescription }} </span>
      </div>
      <div
        class="d-flex flex-column text-blue-darken-2"
        :class="title ? 'mt-1' : ''">
        <div v-for="(btn, index) in button" :key="index" class="">
          <v-btn size="small" variant="flat" :width="btn.width ? btn.width : 72" height="16" color="blue-darken-2" class="mr-1 tooltip-chip">
            {{ btn.name }}
          </v-btn>
          <span>
            {{ btn.content }}
          </span>
          <div v-if="btn.subContent" class="text-grey-darken-2 text-12">
            {{ btn.subContent }}
          </div>
        </div>
      </div>
      <div class="d-flex flex-column text-black">
        <div
          v-for="(eachRule, index) in rule"
          :key="index"
          :class="title && index === 0 ? '' : ''">
          <v-icon size="small" color="green" class="mr-1">mdi-check-circle</v-icon>
          <span>
            {{ eachRule }}
          </span>
        </div>
      </div>
    </v-card>
  </v-tooltip>
</template>

<style scoped>
:deep(.brick-tooltip-content) {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
}

:deep(.brick-tooltip-card) {
  border: none !important;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12) !important;
}

.tooltip-chip {
  font-size: 10px;
  letter-spacing: 0.2px;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  props: {
    /** @type {string} */
    overTitle: {
      type: String,
      default: '',
    },
    /** @type {string} */
    title: {
      type: String,
      default: '',
    },
    /** @type {string | string[]} */
    description: {
      type: [String, Array],
      default: '',
    },
    /** @type {string} */
    subDescription: {
      type: String,
      default: '',
    },
    /** @type {Array<{name: string, content: string, subContent?: string, width?: number}>} */
    button: {
      type: Array,
      default: () => [],
    },
    /** @type {string[]} */
    rule: {
      type: Array,
      default: () => [],
    },
    /** @type {number} */
    size: {
      type: Number,
      default: 0,
    },
    /** @type {string} */
    color: {
      type: String,
      default: '',
    },
    /** @type {number} */
    width: {
      type: Number,
      default: 0,
    },
    /** @type {string} */
    temp: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      /** @type {Record<string, never>} */
    }
  },
})
</script>

<style scoped>
.v-tooltip__content.menuable__content__active {
  opacity: 1 !important;
}
</style>
